import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Complete 7 Daily Check-ins in a row </h5>
        <p> 7 Daily check-ins will bring you <strong>70</strong> points and one step closer to the <strong>2.000</strong> points reward. </p>
      </div>
      <Link className="btn action btn-primary" to={"/check-in"}>Start Offer</Link>
    </Fragment>
  );
};

export default Description;
